/**
 * @file BarPercentNumericalCell.tsx
 * @description cellType = BarPercentNumerical — 条形背景 + 数值条件前景同列叠加。
 *
 * 与 BarPercentCell 的差异：label 内嵌 NumericalValueContent（色 + 图标），
 * 根节点多修饰符 dbl-table-bar-percent--numerical（前景 z-index 高于条）。
 */

import React, { useMemo } from 'react';

import type { IAliTableCellComponentProps } from '@customComp/AliTableAnalytics/types';
import { resolveBarPercentPresentation } from '@customComp/AliTableAnalytics/utils/barPercentPresentation';
import NumericalValueContent from './NumericalValueContent';

const BarPercentNumericalCell: React.FC<IAliTableCellComponentProps> = props => {
  const { text, row, column } = props;
  const { safePercent, backgroundColor, showPlainTextOnly } = useMemo(
    () => resolveBarPercentPresentation(row, column),
    [row, column],
  );

  if (showPlainTextOnly) {
    return <>{text}</>;
  }

  return (
    <div className="dbl-table-bar-percent dbl-table-bar-percent--numerical">
      <div className="dbl-table-bar-percent-fill">
        <div
          className="dbl-table-bar-percent-fill-bar"
          style={{ width: `${safePercent}%`, backgroundColor }}
        />
      </div>
      <div className="dbl-table-bar-percent-label">
        <NumericalValueContent text={text} row={row} column={column} />
      </div>
    </div>
  );
};

export default BarPercentNumericalCell;
